module.exports = __webpack_public_path__ + "img/197.f65552fe.jpg";